import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../store/auth';
import { useEffect } from 'react';

// function CompanyGuard({ element }: { element?: React.ReactNode | React.ComponentType }) {
//   const { isLoading, isAuthenticated, company } = useAuth();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (!isAuthenticated && !isLoading) {
//       navigate('/login');
//     }

//     if (!company) {
//       navigate('/dashboard/select-company');
//     }
//   }, [isAuthenticated]);

//   if (isLoading || !isAuthenticated) {
//     return <></>;
//   }

//   if (!company) {
//     return <></>;
//   }

//   const Element: React.ComponentType = element as React.ComponentType;

//   return <>{element && typeof element === 'function' ? <Element /> : element}</>;
// }

// export { CompanyGuard };

function OnboardingCompletedGuard({ element }: { element?: React.ReactNode }) {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.account.progress_step === 'concluded') {
      navigate('/dashboard');
    }
  }, [isAuthenticated, user]);

  if (user?.account.progress_step === 'concluded') {
    return <></>;
  }

  return <>{element}</>;
}

export { OnboardingCompletedGuard };
